import { createWithEqualityFn } from "zustand/traditional";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { createAuthSlice } from "./createAuthSlice";
import { createLoadingIndicatorSlice } from "./createLoadingIndicatorSlice";
import { createMenuSlice } from "./createMenuSlice";
import { createMessageBoxSlice } from "./createMessageBoxSlice";
import { createTabMenuSlice } from "./createTabMenuSlice";
import { createUserSlice } from "./createUserSlice";
import { createAuthBtnSlice } from "./createAuthBtnSlice";
import { createDigitalSignSlice } from "./createDigitalSignSlice";
import {creatToastActionSlice} from "@maxis/client-logic/store/creatToastActionSlice";

const store = (...a) => ({
  loadingIndicator: { ...createLoadingIndicatorSlice(...a) },
  toastAction: {...creatToastActionSlice(...a)},
  menu: { ...createMenuSlice(...a) },
  authBtn: { ...createAuthBtnSlice(...a) },
  messageBox: { ...createMessageBoxSlice(...a) },
  user: { ...createUserSlice(...a) },
  tabMenu: { ...createTabMenuSlice(...a) },
  digitalSign: { ...createDigitalSignSlice(...a) },
  ...createAuthSlice(...a),
});

export const useBoundStore = createWithEqualityFn(
  immer(process.env.NODE_ENV !== "production" ? devtools(store) : store)
);
